import { DotLegalButton, DotLegalPageHeader, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import { useTranslation } from "../../localization/useTranslation";
import useSystemNotificationHooks from "./SystemNotifications.hooks";
import SystemNotificationDialog from "./systemNotificationDialog/SystemNotificationDialog";
import { SystemNotificationViewModel } from "./SystemNotifications.types";
import DotLegalTableWithControlsLocalized from "@common/components/dotLegalTableWithControlsLocalized/DotLegalTableWithControlsLocalized";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function SystemNotifications() {
    const { translateString, translateDate } = useTranslation();
    const { setShowDialog, showDialog, data, isLoading, refetch, setSystemNotificationForEdit, systemNotificationForEdit } = useSystemNotificationHooks();

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={[{ name: translateString("systemAnnouncements") }]}
                rightComponent={
                    <DotLegalButton buttonType="primary" size="medium" onClick={() => setShowDialog(true)}>
                        {translateString("createSystemAnnouncement")}
                    </DotLegalButton>
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControlsLocalized
                    internalScroll
                    getUserSpecificPageLength={() => 30}
                    headers={getHeaders(translateString)}
                    defaultOrderBy={"publishedDate"}
                    defaultOrder="desc"
                    data={data}
                    isLoading={isLoading}
                    renderRow={(row, i) => (
                        <TableRow onClick={() => setSystemNotificationForEdit(row)} key={i}>
                            <TableCell>{row.title}</TableCell>
                            <TableCell>{row.publishedDate ? translateDate(row.publishedDate) : translateString("draft")}</TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>

            {(showDialog || systemNotificationForEdit !== undefined) && (
                <SystemNotificationDialog
                    onDialogClose={() => {
                        setShowDialog(false);
                        setSystemNotificationForEdit(undefined);
                    }}
                    onSave={() => {
                        refetch();
                        setShowDialog(false);
                        setSystemNotificationForEdit(undefined);
                    }}
                    selectedSystemNotification={systemNotificationForEdit}
                />
            )}
        </Box>
    );
}

export default SystemNotifications;

function getHeaders(translateString: any) {
    let headers = Array<ITableHeader<SystemNotificationViewModel>>();
    headers.push({ property: "title", text: translateString("title"), align: "left", showOnMobile: true });
    headers.push({ property: "publishedDate", text: translateString("publishedDate"), align: "left", showOnMobile: true });
    return headers;
}
